/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-select-input .select-wrapper.is-open:after{-ms-transform:none!important;transform:none!important}"];
export { styles as styles };
